import React, {ReactNode} from "react";

export interface PageContentProps {
    children: ReactNode | ReactNode[]
}

const PageContent = ({children}: PageContentProps) => {

    return (
        <div className="page-content">
            {children}
        </div>
    )

}

export default PageContent;